import React, { useState } from 'react';
import { Fund } from '../api/useFunds';
import { CashbackModel } from '../utils/cashbackConstants';
import DetailCalculator from './DetailCalculator';
import { mapToCache, bicFromCache } from './cashbackCalculatorUtil';
import { useInitialState } from './hooks/useInitialState';

export interface Props {
  model?: CashbackModel;
  bookNowUrl: string;
  onStateChange?: (state: Record<string, number>, bic: Bic) => void;
  defaultState?: Record<string, number>;
  defaultBic?: string;
}

export const DetailCalculatorWithLocalStorage = ({
  bookNowUrl,
  model = 'flat-fee',
  onStateChange,
  defaultState,
  defaultBic,
}: Props) => {
  const [initialBic] = useState(defaultBic || bicFromCache());
  const { data: initialState, isLoading } = useInitialState(defaultState);

  const handleStateChange = (state: Map<Fund, number>, bic: Bic) => {
    const isinToValue: Record<string, number> = {};
    state.forEach((v, k) => {
      isinToValue[k?.isin || ''] = v;
    });
    onStateChange && onStateChange(isinToValue, bic);
    mapToCache(state, bic);
  };

  if (isLoading && defaultState) {
    return null;
  }

  return (
    <DetailCalculator
      model={model}
      initialState={initialState}
      initialBic={initialBic as Bic}
      onStateChange={handleStateChange}
      bookNowUrl={bookNowUrl}
    />
  );
};

export default DetailCalculatorWithLocalStorage;
